const lineItemBulkView = () => {
    const classes = {
        bulkViewLineItemWaiting: 'line-item--bulk-view-product-waiting',
    };
    const selectors = {
        bulkViewLineItem: '[data-line-item-bulk-view]',
        bulkViewLineItemUpdateMethodAttr: 'data-line-item-bulk-view-update',
        bulkViewLineItemVariantInput: '[data-line-item-bulk-view-variant-input]',
        bulkViewLineItemVariantID: 'data-variant-id',
        bulkViewUpdateCartButton: '[data-bulk-view-update-button]',
    };
    const handleBulkViewLineItemUpdates = () => {
        const bulkViewLineItems = document.querySelectorAll(selectors.bulkViewLineItem);
        const bulkViewUpdateCartButton = document.querySelector(selectors.bulkViewUpdateCartButton);
        bulkViewLineItems.forEach((item) => {
            const updateMethod = item.getAttribute(selectors.bulkViewLineItemUpdateMethodAttr);
            const variantInputs = item.querySelectorAll(selectors.bulkViewLineItemVariantInput);
            variantInputs.forEach((variantInput) => {
                if (updateMethod == 'auto') {
                    variantInput.addEventListener('change', () => {
                        bulkViewLineItems.forEach((line) => {
                            line.classList.add(classes.bulkViewLineItemWaiting);
                        });
                        const updates = {};
                        bulkViewLineItems.forEach((lineItem) => {
                            const inputs = lineItem.querySelectorAll(selectors.bulkViewLineItemVariantInput);
                            inputs.forEach((input) => {
                                const variantID = input.getAttribute(selectors.bulkViewLineItemVariantID);
                                let quantity = parseInt(input.value, 10);
                                if (Number.isNaN(quantity) || quantity < 0)
                                    quantity = 0;
                                if (variantID) {
                                    updates[variantID] = quantity;
                                }
                            });
                        });
                        if (Object.keys(updates).length > 0) {
                            fetch(window.Shopify.routes.root + 'cart/update.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({ updates }),
                            })
                                .then((response) => {
                                return response.json();
                            })
                                .then((data) => {
                                document.dispatchEvent(new CustomEvent('cart:refresh'));
                            })
                                .catch((error) => {
                                console.error('Error:', error);
                            });
                        }
                    });
                }
                if (updateMethod == 'on-click') {
                    variantInput.addEventListener('change', () => {
                        bulkViewUpdateCartButton.classList.remove('button--hidden');
                    });
                }
            });
        });
    };
    handleBulkViewLineItemUpdates();
    const getUpdateCartButton = () => {
        const bulkViewUpdateCartButton = document.querySelector(selectors.bulkViewUpdateCartButton);
        if (!bulkViewUpdateCartButton)
            return;
        const handleClick = () => {
            bulkViewUpdateCartButton.style.setProperty('opacity', '0.25');
            bulkViewUpdateCartButton.style.setProperty('pointer-events', 'none');
            const updates = {};
            const bulkViewLineItems = document.querySelectorAll(selectors.bulkViewLineItem);
            bulkViewLineItems.forEach((lineItem) => {
                const updateMethod = lineItem.getAttribute(selectors.bulkViewLineItemUpdateMethodAttr);
                if (updateMethod != 'on-click') {
                    return;
                }
                lineItem.classList.add(classes.bulkViewLineItemWaiting);
                const inputs = lineItem.querySelectorAll(selectors.bulkViewLineItemVariantInput);
                inputs.forEach((input) => {
                    const variantID = input.getAttribute(selectors.bulkViewLineItemVariantID);
                    let quantity = parseInt(input.value, 10);
                    if (Number.isNaN(quantity) || quantity < 0)
                        quantity = 0;
                    if (variantID) {
                        updates[variantID] = quantity;
                    }
                });
            });
            if (Object.keys(updates).length > 0) {
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ updates }),
                })
                    .then((response) => {
                    return response.json();
                })
                    .then(() => {
                    document.dispatchEvent(new CustomEvent('cart:refresh'));
                })
                    .catch((error) => {
                    console.error('Error:', error);
                });
            }
        };
        bulkViewUpdateCartButton.removeEventListener('click', handleClick);
        bulkViewUpdateCartButton.addEventListener('click', handleClick);
    };
    getUpdateCartButton();
    const cartDrawer = document.querySelector('.cart-drawer');
    if (cartDrawer) {
        const observer = new MutationObserver(() => {
            window.setTimeout(() => {
                getUpdateCartButton();
                handleBulkViewLineItemUpdates();
            }, 300);
        });
        observer.observe(cartDrawer, { childList: true, subtree: true });
    }
};
export { lineItemBulkView };
